import { useParams } from "react-router";

/**
 * react-router の `:code` path param を **安全に decode** する純粋関数。
 *
 * react-router 6+ は `useParams` の段階で path param を自動 decode するので、追加の decode は
 * 基本 no-op。ただし `%` を含む不正な percent-escape (例: `%E3` で途切れている、`%xx` で xx が
 * 16 進でない、等) が来ると `decodeURIComponent` が `URIError` を投げる経路があり得るため
 * try/catch で防御する。fallback はデコード前の生値 (= API で 404 になる無害なパス)。
 *
 * 元々は `return-form.tsx` のローカルヘルパだったが、`address-form.tsx` /
 * `order-detail.tsx` / `receipt.tsx` も同じ `params.code ? decodeURIComponent(params.code) : ""`
 * パターン (= ガード無し) を持っていたので、ここに集約。
 */
export const decodeOrderCode = (raw: string | undefined): string => {
  if (!raw) return "";
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

/**
 * `useParams<{ code: string }>` + `decodeOrderCode` を結合したフック。
 * mypage の `/orders/:code/...` パスを持つページは全てこれを使うこと。
 */
export const useDecodedOrderCode = (): string => {
  const params = useParams<{ code: string }>();
  return decodeOrderCode(params.code);
};
